@if (formStep) {
  <wl-progressive-form-step-wrapper
    [rendering]="rendering"
    [title]="content.title.value"
    [stepName]="formStep?.stepId"
    [submitButtonText]="content.genericFields?.submitButtonText.value"
    submitButtonIcon="arrow-down"
    [submitButtonAutomationId]="submitButtonAutomationId"
    [progressiveFormSelectorKey]="progressiveFormSelectorKey"
    [formState]="formStep?.formState"
    [showWhenFutureStep]="false"
    [showSeperator]="false"
    [isReadonly]="isReadonly"
  >
    <ng-template wlProgressiveFormBody>
      @if (formStep?.hasGenericError) {
        <wl-error-card
          class="mb-2"
          [mode]="'content'"
          [message]="content.genericFields?.errorMessage"
        ></wl-error-card>
      }
      <div class="d-flex flex-wrap">
        @for (questionOption of questionOptions; track questionOption) {
          <button
            [wlAutomationId]="
              progressiveFormSelectorKey +
              '-' +
              formStep?.stepId +
              '-' +
              questionOption.value +
              '-button'
            "
            type="button"
            wlCSCapture
            class="btn btn-outline-primary toggle-button mb-1 me-1"
            [class.active]="isActive(questionOption.value)"
            (click)="
              setValue(
                questionOption.value,
                formStep?.formState?.controls?.field
              )
            "
            wlTrackLink
            [trackLinkInfo]="{
              rendering: rendering,
              field:
                progressiveFormSelectorKey +
                ' ' +
                formStep?.stepId +
                ' ' +
                questionOption.value,
              type: 'button',
              eventType: 'button-click',
            }"
          >
            {{ questionOption.label.value }}
          </button>
        }
      </div>
      <wl-more-info-button
        [explanation]="content.explanation"
        [rendering]="rendering"
        (giveMoreInfo)="giveMoreInfo.emit(content?.explanation)"
      ></wl-more-info-button>
    </ng-template>

    <ng-template wlProgressiveFormSummary>
      <ul>
        @for (value of formStep?.formState?.value?.field; track value) {
          <li>
            {{ translateRadioOption(value, questionOptions) }}
          </li>
        }
      </ul>
    </ng-template>
  </wl-progressive-form-step-wrapper>
}
